import React, { Component } from "react";
import Link from "gatsby-link";
import styles from "./TeamLeaderItem.module.scss";

function createMarkup(value) {
	return {
		__html: value
	};
}

const TeamLeaderItem = ({
	locale,
	photo,
	slug,
	job_title,
	researchInterests,
	name,
	degree,
	bio,
	email,
	profile_url,
	pubMed,
	researchGate,
	mahidolProfile,
	linkedInProfile
}) => (
	<div className={"col-12 " + styles.leader_item}>
		<div className="row justify-content-between">
			<div
				className={ styles.photo_col}
				style={{
					backgroundImage: "url(" + photo + ")"
				}}
			/>
			<div className={styles.profile}>
				<small className={styles.job_title}>{job_title} | {researchInterests[0].title}
				</small>

				{slug ? (
					<h4 className={styles.name}>
						<Link to={`/${locale}/team/${slug}`}>{name}</Link>
					</h4>
				) : (
					<h4 className={styles.name}>{name}</h4>
				)}

				<small className={styles.degree}>{degree}</small>

				<span
					className={styles.description}
					dangerouslySetInnerHTML={createMarkup(bio.html)}
				/>

				<div className={styles.contact_details}>
					{email && (
						<span>
							<i className="envelope" />
							{email}
						</span>
					)}
				</div>

				<ul className={styles.member_link_list}>
					{pubMed && (
						<li className={styles.member_link_item}>
							<a
								href={pubMed}
								target="_blank"
								className={styles.member_link}
							>
								Publications
							</a>
						</li>
					)}
					{researchGate && (researchGate !== "-") && (
						<li className={styles.member_link_item}>
							<a
								href={researchGate}
								target="_blank"
								className={styles.member_link}
							>
								ResearchGate
							</a>
						</li>
					)}
					{mahidolProfile && (mahidolProfile !== "-") && (
						<li className={styles.member_link_item}>
							<a
								href={mahidolProfile}
								target="_blank"
								className={styles.member_link}
							>
								Mahidol Profile
							</a>
						</li>
					)}
					{linkedInProfile && (linkedInProfile !== "-") && (
						<li className={styles.member_link_item}>
							<a
								href={linkedInProfile}
								target="_blank"
								className={styles.member_link}
							>
								LinkedIn
							</a>
						</li>
					)}
				</ul>
			</div>
		</div>
	</div>
);

export default TeamLeaderItem;



// WEBPACK FOOTER //
// ./src/components/team-leader-item/index.js